import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Tooltip } from "@mui/material";
import { Fragment, useState } from "react";
import type { GlobalModal } from "../../context/GlobalModalProvider";
import Flex from "../Flex";
import { DraggableModal } from "./DraggableModal";

export const DraggableModalWrapper = <T,>({
  ...dialog
}: GlobalModal<T> & { onClose: () => void; index: number }) => {
  if (!dialog.id) return null;

  const [pinnedDialogs, setPinnedDialogs] = useState<string[]>([]);

  const content = dialog.content?.((dialog.params ?? ({} as T)) as T);
  const isPinned = pinnedDialogs.includes(dialog.id);

  const calculatedTop = (90 * (dialog.index + 1)) / 1.3;
  return (
    <Fragment key={dialog.id}>
      <div style={{ display: !isPinned ? "block" : "none" }}>
        <DraggableModal
          {...dialog}
          onPin={() => setPinnedDialogs((prev) => [...prev, dialog.id])}
          onClose={dialog.onClose}
        >
          {content}
        </DraggableModal>
      </div>

      {/* Pinned sidebar icon */}
      <Flex
        height={"52px"}
        maxHeight={"62px"}
        bgcolor={"primary.main"}
        display={isPinned ? "flex" : "none"}
        borderRadius={"0px 6px 6px 0px"}
        alignItems={"center"}
        top={90}
        justifyContent={"center"}
        sx={{
          cursor: "pointer",
          position: "absolute",
          top: calculatedTop,
          zIndex: dialog.zIndex,
        }}
        onClick={() =>
          setPinnedDialogs(pinnedDialogs.filter((d) => d !== dialog.id))
        }
      >
        <Tooltip
          title={dialog.title || "Pinned Dialog"}
          placement="right"
          arrow
        >
          <ChevronRightIcon fontSize="small" sx={{ color: "white" }} />
        </Tooltip>
      </Flex>
    </Fragment>
  );
};
